const handleCreateCustomerFromContactForm = () => {
  const $customerForm = $('.js-customer-form');
  const $contactForm = $('.js-contact-form-create-customer');

  if ($customerForm.length === 0) {
    return;
  }

  $contactForm.on('input', '.field', function() {
    const $this = $(this);
    const nameAttr = $this.attr('name').replace('contact', 'customer');
    const $targetField = $customerForm.find(`[name="${nameAttr}"]`);

    if ($targetField.length > 0) {
      $targetField.val($this.val());
    }
  });

  $contactForm.find('form').on('submit', function(event) {
    const $customerFormTag = $customerForm.find('form');
    const passwordField = $customerFormTag.find('[type="password"]');
    const randomPassword = Math.floor(100000 + Math.random() * 900000);

    passwordField.val(randomPassword);

    if (! $customerForm.hasClass('form--success')) {
      $.ajax({
        url: $customerFormTag.attr('action'),
        type: 'POST',
        data: $customerFormTag.serialize(),
        success() {
          $customerForm.addClass('form--success');

          $contactForm
            .find('form')
            .trigger('submit');
        },
        error(err) {
          alert(err.responseJSON.description);
        },
      });

      event.preventDefault();
    }
  });
}

handleCreateCustomerFromContactForm();
